module.exports = __webpack_public_path__ + "static/media/TireRotation.315bfcd2.svg";